module.exports = __webpack_public_path__ + "img/prev-item.e899ec6f.png";